import { type Reservation, type ReservationData } from '../types';
import { convertChildEvents } from './convertChildEvents';
import { isNotDeleted } from './isNotDeleted';

export function reservationDataToReservation(reservationData: ReservationData): Reservation {
    const unique = reservationData.reservation.resources.filter(
        ({ resource: e, deleted }, i) =>
            isNotDeleted({ deleted }) &&
            reservationData.reservation.resources.findIndex(
                ({ resource: a, deleted: d }) => !d && a.resourceId === e.resourceId
            ) === i
    );

    reservationData.reservation.resources = unique;
    return {
        ...reservationData.reservation,
        events: convertChildEvents(reservationData.reservation.events),
        dateFrom: new Date(reservationData.reservation.dateFrom),
        dateTo: new Date(reservationData.reservation.dateTo),
        quotationId: reservationData.quotationId,
    };
}
